import React, { useState } from "react";

export const DragDropZone = ({ onFileUpload, children, className = "" }) => {
  const [dragActive, setDragActive] = useState(false);
  const [dragCounter, setDragCounter] = useState(0);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(prev => prev + 1);
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragActive(true);
    }
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(prev => prev - 1);
    if (dragCounter - 1 === 0) {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    setDragCounter(0);
    
    if (!e.dataTransfer?.files || e.dataTransfer.files.length === 0) {
      console.warn('No files in drop event');
      return;
    }

    const files = Array.from(e.dataTransfer.files);
    files.forEach(file => {
      // Comprehensive file validation
      if (!file) {
        console.warn('Null file in drop event');
        return;
      }

      if (!file.name || typeof file.name !== 'string') {
        console.warn('Invalid file dropped - missing or invalid name:', file);
        alert('Invalid file. Please select a valid file with a proper name.');
        return;
      }

      try {
        const fileData = {
          name: file.name,
          size: formatFileSize(file.size || 0),
          type: file.type || 'application/octet-stream',
          url: URL.createObjectURL(file),
          file: file
        };
        
        // Validate fileData before passing it on
        if (!fileData.name) {
          throw new Error('File data validation failed');
        }
        
        onFileUpload(fileData);
      } catch (error) {
        console.error('Error processing dropped file:', error);
        alert(`Error processing file: ${file.name || 'Unknown'}. Please try again.`);
      }
    });
    
    try {
      e.dataTransfer.clearData();
    } catch (error) {
      console.warn('Could not clear drag data:', error);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div
      className={`relative ${className}`}
      onDragEnter={handleDragIn}
      onDragLeave={handleDragOut}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      {children}
      
      {/* Drag overlay */}
      {dragActive && (
        <div className="absolute inset-0 bg-blue-50 bg-opacity-90 border-2 border-dashed border-[#3d6be0] rounded-lg flex items-center justify-center z-50">
          <div className="text-center">
            <div className="text-6xl mb-4">📤</div>
            <h3 className="text-xl font-semibold text-[#3d6be0] mb-2">Drop files here</h3>
            <p className="text-gray-600">Release to upload files</p>
          </div>
        </div>
      )}
    </div>
  );
};
